import React from "react";
import { Link } from "react-router-dom";
// import Quote from "./Quote";

const serviceCards = [
  {
    title: "Partner and Family Visa",
    href: "/services/partner-and-family-visa",
    description:
      "UK visa support for partners, children, and family members who want to live together.",
  },
  {
    title: "ELA Nationals & Family",
    href: "/services/immigration-law/ela-nationals-family",
    description:
      "Advice for Eritrean, Libyan and other ELA national family visa applications.",
  },
  {
    title: "Short Stay Visit Visas",
    href: "/services/immigration-law/short-stay-visit-visas",
    description:
      "Guidance for family visits, medical travel and short-term business visits to the UK.",
  },
  {
    title: "Work Visas",
    href: "/services/immigration-law/work-visas",
    description:
      "Visa routes for skilled workers, sponsors and specialist professionals.",
  },
  {
    title: "Business Immigration",
    href: "/services/immigration-law/business-immigration",
    description:
      "Business visa advice for investors, entrepreneurs and company transfers.",
  },
  {
    title: "Student & Graduate Visas",
    href: "/services/immigration-law/student-graduate-visas",
    description:
      "Support for study, post-graduate work and switching to longer-term visas.",
  },
  {
    title: "Settlement in the UK",
    href: "/services/immigration-law/settlement-uk",
    description:
      "Long-term residence and indefinite leave to remain advice for families and partners.",
  },
  {
    title: "British Citizenship",
    href: "/services/immigration-law/british-citizenship",
    description:
      "Naturalisation guidance for those qualifying through family, residence or marriage.",
  },
  {
    title: "Human Rights",
    href: "/services/immigration-law/human-rights",
    description:
      "Human rights and family life claims where immigration decisions affect your family.",
  },
  {
    title: "Asylum and Appeal",
    href: "/services/immigration-law/asylum-appeal",
    description:
      "Appeals and family-based support for asylum seekers with ongoing protection needs.",
  },
];

const ImmigrationLaw = () => {
  return (
    <div className="relative bg-white pt-20">
      {/* Floating Lady Justice (desktop only, fixed right, non-scrolling, transparent, left-70% showing, below navbar) */}
      <div
        className="pointer-events-none fixed right-0 top-28 xl:top-32 z-10 hidden lg:block select-none"
        aria-hidden="true"
      >
        <img
          src="/lady-justice.png"
          alt=""
          className="h-[580px] xl:h-[680px] 2xl:h-[760px] w-auto max-w-none object-contain opacity-20 translate-x-[30%]"
        />
      </div>

      <section className="relative overflow-hidden bg-[rgb(26,36,58)] py-8 text-white lg:pt-20">
        <div className="container relative mx-auto px-4">
          <div className="max-w-3xl">
            <div className="mb-6 flex items-center gap-3 text-sm font-semibold text-[#C9A04A]">
              <Link to="/" className="hover:text-white">
                Home
              </Link>
              <span>/</span>
              <Link to="/#services" className="hover:text-white">
                Services
              </Link>
              <span>/</span>
              <span>Immigration Law</span>
            </div>
            <h1 className="mb-6 text-4xl font-bold leading-tight lg:text-6xl">
              Immigration Law
            </h1>
            <p className="max-w-2xl text-base leading-8 text-white/85 lg:text-lg">
              Clear, practical immigration advice for individuals and families
              navigating UK entry, settlement and citizenship pathways.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-[#C9A04A] px-6 py-3 font-bold text-[rgb(26,36,58)] hover:bg-white"
              >
                Get advice
              </a>
              <a
                href="tel:+4401216306635"
                className="inline-flex items-center justify-center border border-white/40 px-6 py-3 font-bold text-white hover:border-yellow hover:text-[#C9A04A]"
              >
                Call +44 (0) 121 630 6635
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-light-grey py-8">
        <div className="container relative mx-auto px-4">
          <div className="relative z-10 text-center mb-12 max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-[rgb(26,36,58)] mb-4">
              Our immigration service areas
            </h2>
            <p className="text-gray-700 leading-8">
              Explore our specialist immigration routes and choose the service
              that best fits your family or personal circumstances.
            </p>
          </div>

          <div className="relative z-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {serviceCards.map((card, idx) => {
              // Determine if this is the last card and it would be alone in the row
              const isLast = idx === serviceCards.length - 1;
              const remainderMd = serviceCards.length % 2;
              const remainderXl = serviceCards.length % 3;
              let extraClasses = '';
              if (isLast) {
                if (remainderXl === 1) {
                  extraClasses = ' xl:col-start-2';
                } else if (remainderXl === 2) {
                  extraClasses = ' xl:col-start-3';
                } else if (remainderMd === 1) {
                  extraClasses = ' md:col-start-2';
                }
              }
              return (
                <Link
                  key={card.title}
                  to={card.href}
                  className={`group rounded-3xl bg-white p-8 shadow-panel transition-all duration-200 hover:-translate-y-1 hover:shadow-lg${extraClasses}`}
                >
                  <h3 className="text-xl font-bold text-purple-600 mb-3">
                    {card.title}
                  </h3>
                  <p className="text-gray-600 leading-7">{card.description}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* <Quote /> */}
    </div>
  );
};

export default ImmigrationLaw;
